import { render, staticRenderFns } from "./content.vue?vue&type=template&id=bf735848&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf735848",
  null
  
)

export default component.exports